/**
 * Whether a receiver can act as retenedor at all.
 *
 * Only personas morales withhold in the supuestos this flow models (RFC: moral = 12
 * chars, física = 13), and the generic RFCs never do: XAXX010101000 is público en
 * general and XEXX010101000 a foreign receiver, neither of which is a taxpayer that
 * could withhold anything.
 *
 * This is the single source of truth for that question. Retention state lives on the
 * concept but is a property of the issuer-receiver relationship, so every path that
 * sets or restores it has to ask here — otherwise a concept keeps withholdings that
 * belonged to a receiver the user already replaced.
 */
export const receiverCanWithhold = (rfc?: string | null): rfc is string => {
  const value = rfc?.trim().toUpperCase() ?? '';
  if (value === 'XAXX010101000' || value === 'XEXX010101000') return false;
  return value.length === 12;
};

/**
 * Initial "venta de bienes" guess from the SAT ClaveProdServ. The catalog is UNSPSC and
 * its first two digits are the segment: 10 to 60 group goods (materials, merchandise,
 * livestock), 70 and up group services. Only a DEFAULT for the editable checkbox, and only
 * honoured by 626/612; when in doubt it returns false, which keeps the withholding on.
 *
 * Pendiente de validación con Taxes (Karla) antes de tratarlo como regla fiscal.
 */
export const inferIsGoods = (productCode?: string): boolean => {
  const segment = Number((productCode ?? '').slice(0, 2));
  return Number.isFinite(segment) && segment >= 10 && segment <= 60;
};
